import React from "react";
import "./mallproduct.css";

function Malldaraz({ malldata }) {
  return (
    <div className="mallproduct-container">
      {malldata.map((data) => (
        <div className="mallproduct-info" key={data.id}>
          <div className="mallproduct-image">
            <img src={data.imageurl} alt="" />
          </div>
          <div className="mallproduct-detail">
            <image className="mallproduct-logo" src={data.logourl} alt="" />
            <h3>{data.title}</h3>
            <p>{data.desc}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Malldaraz;
